import { render, staticRenderFns } from "./DashboardAulasInfo.vue?vue&type=template&id=e1e852c0&scoped=true"
import script from "./DashboardAulasInfo.vue?vue&type=script&lang=js"
export * from "./DashboardAulasInfo.vue?vue&type=script&lang=js"
import style0 from "./DashboardAulasInfo.vue?vue&type=style&index=0&id=e1e852c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e852c0",
  null
  
)

export default component.exports